import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/jobs/transmittalsReportActions'
import * as api from '../../../api/reports/jobs/transmittalsReport'

function* transmittalsReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.TRANSMITTALS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TRANSMITTALS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* transmittalsReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({
      type: constants.TRANSMITTALS_REPORT_GET_ORGANIZATION_LIST.SUCCESS,
      payload
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TRANSMITTALS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* transmittalsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.TRANSMITTALS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TRANSMITTALS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchtransmittalsReportGetJobList() {
  yield takeLatest(constants.TRANSMITTALS_REPORT_GET_JOB_LIST.ACTION, transmittalsReportGetJobList)
}

function* watchtransmittalsReportGetOrganizationList() {
  yield takeLatest(
    constants.TRANSMITTALS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    transmittalsReportGetOrganizationList
  )
}

function* watchtransmittalsReportGetFullReport() {
  yield takeLatest(
    constants.TRANSMITTALS_REPORT_GET_FULL_REPORT.ACTION,
    transmittalsReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchtransmittalsReportGetOrganizationList),
    fork(watchtransmittalsReportGetFullReport),
    fork(watchtransmittalsReportGetJobList)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/jobs/transmittalsReportSaga.js